import { useEffect, useMemo, useState } from "react";
import { string, func } from "prop-types";
import { useEstimateEditorSettings } from "@tools";
import { TextClearInput } from "@components";
import { Grid } from "@material-ui/core";

export const MaterialTitleCellEditor = ({
  title,
  placeholder,
  onChange,
}) => {
  const { allowEdition } = useEstimateEditorSettings();
  
  const [ focused, setFocus ] = useState(false);
  const [ value, setValue ] = useState(title);
  
  useEffect(() => {
    if(title !== value)
      setValue(title);
  }, [ title ]);
  
  const fieldName = useMemo(() => (
    typeof value === "string" ? value : placeholder
  ), [ value ]);
  
  const handleChange = (name) => {
    setValue(name);
  }
  
  const handleAccept = () => {
    setFocus(false);
    onChange?.(value);
  }
  
  return (
    <Grid
      item container
      wrap="nowrap"
      alignItems="center"
      justifyContent="center"
      className="h-20 text-xs"
    >
      {
        allowEdition
          ? <TextClearInput
            tabIndex={-1}
            className="-mb-1"
            focused={focused}
            onFocus={() => setFocus(true)}
            onChange={handleChange}
            onAccept={handleAccept}
            maxLength={28}
            value={fieldName}
            placeholder={placeholder}
            acceptOnClickAway
            confirmOnEnter
          />
          : <span>{ fieldName }</span>
      }
    </Grid>
  )
}

MaterialTitleCellEditor.propTypes = {
  title: string,
  placeholder: string,
  onChange: func.isRequired,
}